//TODO LINT
/* eslint-disable */

export const getDriverState = ({ driver }) => driver

export const getDriversOptimiserIsLoading = (state) =>
  getDriverState(state).isLoadingDriversOptimiser

export const getDriversOptimiser = (state) =>
  getDriverState(state).driversOptimiser.map(
    ({
      firstname,
      lastname,
      phone,
      vehiculeId,
      id,
      adresseDepart,
      adresseArrivee,
      operationalHours,
      prestation,
    }) => {
      const vehicule = vehiculeId?.id
        ? vehiculeId
        : { vehicule_category: { volumeMax: 20, weight: 2000 } }
      return {
        firstname,
        lastname,
        phone,
        vehiculeId: vehicule,
        id,
        checked: false,
        adresseDepart,
        adresseArrivee,
        operationalHours,
        prestation,
      }
    }
  )

export const getDrivers = (state) => getDriverState(state).drivers

export const getDriversOptimiserCount = (state) =>
  getDriverState(state).driversOptimiserCount

export const getDriversSettingsListIsLoading = (state) =>
  getDriverState(state).isLoadingDriversSettingsList
export const getDriversSettings = (state) => getDriverState(state).driversSettings
export const getDriversSettingsCount = (state) =>
  getDriverState(state).driversSettingsCount
export const getErrorMessageDriversSettings = (state) =>
  getDriverState(state).errorMessage
export const getIsErrorFetchDriversSettings = (state) =>
  getDriverState(state).isErrorFetch

export const getIsSuccessRefreshDriversSettings = (state) =>
  getDriverState(state).isSuccessRefresh

export const getSuccessDriversSettings = (state) => getDriverState(state).success

export const getisLoadingDriverSettingsAction = (state) =>
  getDriverState(state).isLoadingDriverSettingsAction

export const getDriversSettingsList = (state) =>
  getDriverState(state).driversSettingsList
export const getDriversSettingsListCount = (state) =>
  getDriverState(state).driversSettingsListCount
export const getIsLoadingDriversSettings = (state) =>
  getDriverState(state).isLoadingDriversSettings
